export interface GalleryCity {
  /** Display name and image alt text. */
  city: string;
  /** Basename under public/images/reviews/ (served from cdn-static after deploy). */
  img: string;
  /** Geo-page slug: /rooms-for-rent/{slug}. */
  slug: string;
}

// US only, ordered by search demand. Selection rule (2026-09-23): the five US
// cities already in the gallery, then the twenty city pages with the highest
// blended share of US clicks + impressions on /rooms-for-rent/* and
// /roommates/* in Search Console, 2026-06-24..2026-09-21 (state pages such as
// new-jersey-usa excluded -- they live in the state hub). Data:
// test-results/seo/index-page-impl/gsc-us-city-clicks.json. Every slug is an
// active geo page in the SEO service, so no link lands on a noindex fallback.
export const US_GALLERY_CITIES: readonly GalleryCity[] = [
  { city: 'New York', img: 'new-york', slug: 'new-york-ny-usa' },
  { city: 'Los Angeles', img: 'los-angeles', slug: 'los-angeles-ca-usa' },
  { city: 'Houston', img: 'houston', slug: 'houston-tx-usa' },
  { city: 'Chicago', img: 'chicago', slug: 'chicago-il-usa' },
  { city: 'San Diego', img: 'san-diego', slug: 'san-diego-ca-usa' },
  { city: 'Atlanta', img: 'atlanta', slug: 'atlanta-ga-usa' },
  { city: 'Miami', img: 'miami', slug: 'miami-fl-usa' },
  { city: 'Las Vegas', img: 'las-vegas', slug: 'las-vegas-nv-usa' },
  { city: 'San Francisco', img: 'san-francisco', slug: 'san-francisco-ca-usa' },
  { city: 'Oklahoma City', img: 'oklahoma-city', slug: 'oklahoma-city-ok-usa' },
  { city: 'Orlando', img: 'orlando', slug: 'orlando-fl-usa' },
  { city: 'Phoenix', img: 'phoenix', slug: 'phoenix-az-usa' },
  { city: 'Sacramento', img: 'sacramento', slug: 'sacramento-ca-usa' },
  { city: 'Tampa', img: 'tampa', slug: 'tampa-fl-usa' },
  { city: 'Dallas', img: 'dallas', slug: 'dallas-tx-usa' },
  { city: 'Denver', img: 'denver', slug: 'denver-co-usa' },
  { city: 'Memphis', img: 'memphis', slug: 'memphis-tn-usa' },
  { city: 'Columbus', img: 'columbus', slug: 'columbus-oh-usa' },
  { city: 'Philadelphia', img: 'philadelphia', slug: 'philadelphia-pa-usa' },
  { city: 'Fort Worth', img: 'fort-worth', slug: 'fort-worth-tx-usa' },
  { city: 'Kansas City', img: 'kansas-city', slug: 'kansas-city-mo-usa' },
  { city: 'Colorado Springs', img: 'colorado-springs', slug: 'colorado-springs-co-usa' },
  { city: 'Cleveland', img: 'cleveland', slug: 'cleveland-oh-usa' },
  { city: 'Jacksonville', img: 'jacksonville', slug: 'jacksonville-fl-usa' },
  { city: 'Portland', img: 'portland', slug: 'portland-or-usa' },
];
